import { _get, _getAxios } from './serviceMain';


export function getCatalogs(groupCode: string, storeCode: string, card: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card
      });

    const url = '/v3/catalog';

    return _getAxios(url, "GET_CATALOG_TIME", "catalogs", queryParams);

  };